import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCourses, updateCourse } from "../../../services/courseApi";

export default function EditCareerCourse() {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    name: "",
    eligibility: "",
    entrance_exam: "",
    colleges: [],
  });

  // ================= FETCH =================
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getCourses();

        const course = res?.data?.courses?.find(
          (c) => c.id.toString() === id
        );

        if (!course) {
          alert("Course not found");
          return;
        }

        setForm({
          name: course.name || "",
          eligibility: course.eligibility || "",
          entrance_exam: course.entrance_exam || "",
          colleges:
            course.colleges?.length > 0
              ? course.colleges
              : [{ name: "", website: "" }],
        });

        setLoading(false);
      } catch (err) {
        console.error(err);
      }
    };

    fetchData();
  }, [id]);

  // ================= COLLEGE =================
  const handleCollegeChange = (i, field, value) => {
    const updated = [...form.colleges];
    updated[i][field] = value;
    setForm({ ...form, colleges: updated });
  };

  const addCollege = () => {
    setForm({
      ...form,
      colleges: [...form.colleges, { name: "", website: "" }],
    });
  };

  const removeCollege = (i) => {
    const updated = form.colleges.filter((_, idx) => idx !== i);
    setForm({ ...form, colleges: updated });
  };

  // ================= SUBMIT =================
  const handleSubmit = async () => {
    try {
      await updateCourse(id, form);
      alert("Updated successfully");
      window.location.href = "/school-admin/career";
    } catch {
      alert("Update failed");
    }
  };

  if (loading) {
    return <div style={styles.loading}>Loading...</div>;
  }

  return (
    <div style={styles.container}>
      
      <div style={styles.card}>

        <h2 style={styles.title}>Edit Course</h2>

        {/* NAME */}
        <input
          style={styles.input}
          value={form.name}
          placeholder="Course Name"
          onChange={(e) =>
            setForm({ ...form, name: e.target.value })
          }
        />

        {/* ELIGIBILITY */}
        <textarea
          style={styles.input}
          value={form.eligibility}
          placeholder="Eligibility"
          onChange={(e) =>
            setForm({
              ...form,
              eligibility: e.target.value,
            })
          }
        />

        {/* EXAM */}
        <input
          style={styles.input}
          value={form.entrance_exam}
          placeholder="Entrance Exam"
          onChange={(e) =>
            setForm({
              ...form,
              entrance_exam: e.target.value,
            })
          }
        />

        {/* COLLEGES */}
        <h4 style={styles.subTitle}>Colleges</h4>

        {form.colleges.map((c, i) => (
          <div key={i} style={styles.collegeRow}>
            
            <input
              style={styles.inputSmall}
              value={c.name}
              placeholder="College Name"
              onChange={(e) =>
                handleCollegeChange(i, "name", e.target.value)
              }
            />

            <input
              style={styles.inputSmall}
              value={c.website}
              placeholder="Website"
              onChange={(e) =>
                handleCollegeChange(i, "website", e.target.value)
              }
            />

            <button
              onClick={() => removeCollege(i)}
              style={styles.removeBtn}
            >
              ✖
            </button>

          </div>
        ))}

        <button onClick={addCollege} style={styles.addBtn}>
          + Add College
        </button>

        {/* SUBMIT */}
        <button onClick={handleSubmit} style={styles.submitBtn}>
          Update Course
        </button>

      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const styles = {
  container: {
    padding: "30px",
    background: "#f5f7fb",
    minHeight: "100vh",
    fontFamily: "Inter, sans-serif",
  },

  card: {
    maxWidth: "650px",
    margin: "auto",
    background: "#fff",
    padding: "25px",
    borderRadius: "14px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
  },

  title: {
    marginBottom: "20px",
    fontWeight: "700",
  },

  subTitle: {
    marginTop: "20px",
    marginBottom: "10px",
  },

  input: {
    width: "100%",
    padding: "10px",
    marginBottom: "12px",
    borderRadius: "8px",
    border: "1px solid #ddd",
  },

  inputSmall: {
    flex: 1,
    padding: "8px",
    borderRadius: "8px",
    border: "1px solid #ddd",
  },

  collegeRow: {
    display: "flex",
    gap: "10px",
    marginBottom: "10px",
    alignItems: "center",
  },

  removeBtn: {
    background: "#fee2e2",
    color: "#dc2626",
    border: "none",
    padding: "6px 10px",
    borderRadius: "8px",
    cursor: "pointer",
  },

  addBtn: {
    marginTop: "10px",
    background: "#eef2ff",
    padding: "8px 12px",
    borderRadius: "8px",
    border: "none",
    cursor: "pointer",
  },

  submitBtn: {
    marginTop: "20px",
    width: "100%",
    padding: "12px",
    background: "#4f46e5",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontWeight: "600",
    cursor: "pointer",
  },

  loading: {
    padding: "40px",
    textAlign: "center",
  },
};